let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fZZ7S")).then(() => parcelRequire('7rLeu'));